import { useEffect } from "react"
import { FaroInsightsWrapper } from "@/grafana-faro"
import { cn } from "@/lib/utils"
import { useDrawerStore } from "@/stores/useDrawerStore"

interface DrawerWrapperProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  containerId: string
  className?: string
}

const DrawerWrapper = ({ containerId, className }: DrawerWrapperProps) => {
  const drawerName = useDrawerStore((state) => state.drawerName)
  const Component = useDrawerStore((state) => state.DrawerContent)
  const setDirty = useDrawerStore((state) => state.setDirty)

  useEffect(() => {
    if (!drawerName) return

    FaroInsightsWrapper.pushEvent("drawer_opened", { drawerName })
    return () => {
      FaroInsightsWrapper.pushEvent("drawer_closed", { drawerName })
    }
  }, [drawerName])

  return (
    <div className={cn("relative h-full", className)} data-drawerid={containerId}>
      {Component ? <Component onDirty={setDirty} /> : null}
    </div>
  )
}

const useDirtyDrawerMaker = (isDirty: boolean, onDrawerClose?: () => void) => {
  const setDirty = useDrawerStore((state) => state.setDirty)
  const setOnDrawerClose = useDrawerStore((state) => state.setOnDrawerClose)

  useEffect(() => {
    if (onDrawerClose) {
      setOnDrawerClose(onDrawerClose)
    }
  }, [onDrawerClose, setOnDrawerClose])

  useEffect(() => {
    setDirty(isDirty)
  }, [isDirty, setDirty])
}

export { DrawerWrapper, useDirtyDrawerMaker }
